import { lazy } from "react";
import { Navigate } from "react-router-dom";

import EmojiTransportationIcon from "@mui/icons-material/EmojiTransportation";

const TransporterCreate = lazy(() => import("../components/transporterCreate"));
const TransporterList = lazy(() => import("../components/transporterList"));
const TransporterView = lazy(() => import("../components/transporterView"));

const transporterRoute = [
  {
    icon: EmojiTransportationIcon,
    name: "Transport Team",
    link: "transport-team",
    path: "transport-team",
    superAdminView: false,
    index: 21,
    element: <TransporterList />,
    permission: "Transport Team-Read",
  },
  // children: [
  // {
  //   path: "transport-team",
  //   element: <TransporterList />,
  //   permission: "Employee-Read",
  //   name: "Transport Team",
  //   index: 4,
  //   link: "transport-team",
  //   icon: EmojiTransportationIcon,
  // },
  {
    path: "transport-team/create",
    element: <TransporterCreate />,
  },
  {
    path: "transport-team/:id",
    element: <TransporterCreate />,
  },
  {
    path: "transport-team/view/:id",
    element: <TransporterView />,
  },
  {
    path: "",
    element: <Navigate to="transport-team" replace />,
  },
  // ],
];
export default transporterRoute;
